/* eslint-disable max-len */
import React, { FC } from "react";

import MapBubble from "../MapBubble/MapBubble";
import { ILocationItemResponse } from "../../services/edit-hospital-location/edit-hospital-location.interface";

interface IMapMarkerProps {
  size?: number,
  lat: number
  lng: number
  onClick?: () => void
  main?: boolean
  isBubble?: boolean,
  location?: any
  setIsBubble?: ((isBubble: boolean) => void) | undefined
  handleUpdateLocationDetail?: (selectedLocation: ILocationItemResponse) => void,
  handleOpenLocationModal?: () => void
  isSignup?: boolean;
}

const MapMarker: FC<IMapMarkerProps> = ({
  size = 42,
  lat,
  lng,
  onClick,
  main,
  isBubble,
  location,
  setIsBubble,
  handleUpdateLocationDetail,
  handleOpenLocationModal,
  isSignup = false,
}) => {
  const markerClicked = () => {
    if (isSignup) {
      onClick && onClick();
      handleUpdateLocationDetail ? handleUpdateLocationDetail(location): handleOpenLocationModal && handleOpenLocationModal();
    } else {
      onClick && onClick();
    }
  };

  return <>
    {main ? (
      <>
        {isBubble ? <MapBubble onClose={setIsBubble} location={location} updateLocation={handleUpdateLocationDetail}
          handleOpenLocationModal={handleOpenLocationModal} isSignup={isSignup}/> : null}
        <div style={{ position: "absolute", transform: "translate(-50%, -100%)", cursor: "pointer" }} >
          <div onClick={markerClicked} onMouseEnter={isSignup ? onClick : undefined} onMouseLeave={()=> isSignup && setIsBubble && setIsBubble(false)} >
            <svg width={size} height={size} viewBox="-4 0 36 36" version="1.1">
              <g id="Vivid.JS" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Vivid-Icons" transform="translate(-125.000000, -643.000000)">
                  <g id="Icons" transform="translate(37.000000, 169.000000)">
                    <g id="map-marker" transform="translate(78.000000, 468.000000)">
                      <g transform="translate(10.000000, 6.000000)">
                        <path
                          d="M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z"
                          id="Shape"
                          fill="#FEC20D"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <img
              width={size * 0.6}
              style={{
                transform: "translate(-50%, -85%)", position: "absolute",
                top: "50%", left: "50%",
              }}
              alt="gv-yellow-logo"
              src="/assets/icons/google-maps-marker-image.png"
            />
          </div>
        </div>
      </>
    ) : (
      <svg onClick={markerClicked} onMouseEnter={isSignup ? onClick : undefined}
        onMouseLeave={()=>isSignup && setIsBubble && setIsBubble(false)} width="23" height="29" viewBox="0 0 23 29" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: "pointer" }}>
        <path d="M0 11.5C2.24488e-05 17.5 11 29 11 29C11 29 22 18 22.5 11.5C23 5 19.5 0 11 0C2.5 0 -2.24484e-05 5.5 0 11.5Z" fill="#F6C345" />
      </svg>
    )}
  </>;
}
;

export default MapMarker;
